import React, { useEffect, useState } from "react";
import dataService from "../../../../helpers/dataService";

const useAnnualReoByPart = (url, year, otherPostParams) => {
  const [isLoading, setIsLoading] = useState(false);
  const [chartState, setChartState] = useState(false);
  const [total, setTotal] = useState(0);
  const months = [year];
  const [isZeroShow, setIsZeroShow] = useState(true);
  const [orgas, setOrgas] = useState([]);

  useEffect(() => {
    getOrgas();
  }, []);

  const getOrgas = () => {
    dataService.get(`organizations`, setOrgas);
  };

  const lineOptions = {
    chart: {
      height: 350,
      type: "bar",
      zoom: {
        enabled: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "straight",
    },

    grid: {
      row: {
        colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
        opacity: 0.5,
      },
    },
    xaxis: {
      categories: months,
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
  };

  const getDatas = () => {
    setIsLoading(true);

    dataService.post(
      `${url}`,
      { year, ...otherPostParams },
      (datas) => {
        var allTotals = Object.values(datas.global).map((o) =>
          o.year.reduce((a, b) => a + b)
        );

        setTotal(allTotals.reduce((a, b) => a + b));
        setChartState({
          line: {
            series: Object.values(datas.global).map((o) => ({
              name: o.name,
              data: o.year,
            })),
            options: lineOptions,
          },
          pie: {
            series: Object.values(datas.global).map((o) =>
              o.year.reduce((a, b) => a + b)
            ),
            options: {
              labels: Object.values(datas.global).map((o) => o.name),
              legend: { position: "bottom" },
              chart: {
                toolbar: {
                  show: true,
                },
              },
            },
          },
          ...datas,
        });
      },
      (e) => {
        console.log(e);
      },
      () => setIsLoading(false)
    );
  };

  var hasDatas = chartState;
  console.log("chartState", chartState);
  return {
    isLoading,
    getDatas,
    chartState,
    hasDatas,
    total,
    isZeroShow,
    setIsZeroShow,
    orgas,
  };
};

export default useAnnualReoByPart;
